import React from 'react'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import Popup from '@Components/Popups/Popup'
import './index.scss'
import { PaginationBody } from '@Entities/pagination'
import { Blocker } from 'react-router'
import { BulkActionStore, LeavePageSource } from '@App/stores/search/bulk-action-store'

export interface BulkActionLeavePageConfirmationPopupProps {
    runSearch: (pagination?: PaginationBody) => Promise<void>
    blocker: Blocker
    bulkActionStore: BulkActionStore<string, string>
    bulkActionLabel?: string
}
const BulkActionLeavePageConfirmationPopup = ({
    runSearch,
    blocker,
    bulkActionStore,
    bulkActionLabel,
}: BulkActionLeavePageConfirmationPopupProps) => {
    const onClose = () => {
        bulkActionStore.setLeavePageModalClosed()

        if (blocker.state === 'blocked') {
            blocker.reset()
        }
    }

    const onConfirm = async () => {
        if (bulkActionStore.areFilesStaged) {
            bulkActionStore.setAreFilesStaged(false)
        }
        bulkActionStore.resetSelection()
        const pending = bulkActionStore.pendingPagination
        if (bulkActionStore.leavePageSource === LeavePageSource.BackButton) {
            bulkActionStore.setActiveBulkAction(null)
        }
        await runSearch(pending)
        bulkActionStore.setLeavePageModalClosed()
        bulkActionStore.setPendingPagination(undefined)
        if (blocker?.state === 'blocked') {
            blocker?.proceed()
        }
    }

    return (
        <Popup className="bulk-overclaim-leave-page-popup" onClose={onClose}>
            <ConfirmationPopup
                title="Leave this page?"
                onCancel={onClose}
                cancelButtonText="Go back"
                confirmButtonText="Continue without saving"
                onConfirm={onConfirm}
            >
                <h4>You can submit up to 100 works at a time for {bulkActionLabel}</h4>
                You have unsaved selections. If you leave now, your progress will be lost and you'll need to start over.
            </ConfirmationPopup>
        </Popup>
    )
}
export default BulkActionLeavePageConfirmationPopup
